var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen flex flex-col items-center pt-16"},[_vm._m(0),(!_vm.isOptinTooLate)?_c('h1',{staticClass:"max-w-lg mb-4 text-xl text-center",domProps:{"innerHTML":_vm._s(_vm.$t('optinisation.title'))}}):_vm._e(),_c('p',{staticClass:"max-w-lg text-base",domProps:{"innerHTML":_vm._s(
      _vm.isOptinTooLate
        ? _vm.$t('optinisation.subtitleTooLate')
        : _vm.$t('optinisation.subtitle', { client: 'CLIENT_NAME' })
    )}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"cursor-pointer",attrs:{"href":"https://www.valentino-beauty.de/","target":"_blank"}},[_c('img',{staticClass:"block w-56 h-auto mb-8",attrs:{"src":require("@/assets/logos/valentino-beauty.svg"),"alt":""}})])
}]

export { render, staticRenderFns }